import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { CalendarDays, Sparkles } from 'lucide-react';
export function Proof() {
  return <AnimatedSection className="bg-mint text-charcoal relative overflow-hidden" data-id="element-199">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white/20 via-transparent to-transparent pointer-events-none" data-id="element-200" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-201">
        <div className="bg-white/90 backdrop-blur-md p-8 md:p-12 rounded-3xl shadow-xl border border-white/50 text-center space-y-8" data-id="element-202">
          <div className="inline-flex items-center justify-center bg-gold/20 text-gold-dark p-4 rounded-full mb-2" data-id="element-203">
            <CalendarDays className="w-8 h-8" data-id="element-204" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-charcoal leading-tight" data-id="element-205">
            La promesa de los 7 días
          </h2>

          <div className="space-y-6 text-xl text-charcoal-light leading-relaxed max-w-2xl mx-auto" data-id="element-206">
            <p data-id="element-207">
              En solo 7 días, pasarás de reaccionar por impulso a observar tus
              emociones con distancia.
            </p>
            <p data-id="element-208">
              No dejarás de sentir estrés, pero dejarás de ser un esclavo de él.
            </p>
            <p className="font-serif text-2xl md:text-3xl text-charcoal font-bold italic pt-4 flex items-center justify-center gap-3" data-id="element-209">
              <Sparkles className="w-6 h-6 text-gold" data-id="element-210" />
              El silencio en tu casa ya no será de miedo, sino de paz.
              <Sparkles className="w-6 h-6 text-gold" data-id="element-211" />
            </p>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}